import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Redirect from 'react-router-dom/Redirect';
import { withUserData } from 'common/sessionStore/withUserData.js';
import { actionCreators } from './store.js';

class Login extends React.Component {
  constructor(props) {
    super(props);
    this.props.checkLogin(); //call identityserver method to redirect
  }

  render() {
    //redirect back to the previously queried address, saved in the localStorage
    return (
      this.props.isAuthenticated && (
        <Redirect to={this.props.userData.currentPath || '/'} />
      )
    );
  }
}

Login.propTypes = {
  isAuthenticated: PropTypes.bool,
  location: PropTypes.object,
  userData: PropTypes.object, //from withUserData HOC
};

const mapStatetoProps = (state) => {
  return {
    isAuthenticated: state.auth.isAuthenticated,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    checkLogin: () => {
      dispatch(actionCreators.checkLogin());
    },
  };
};

export default connect(
  mapStatetoProps,
  mapDispatchToProps
)(withUserData(Login));
